/**
 * API · core.task_reminders (Snooze del rediseño v2.0).
 *
 * Cada reminder es del user actual (RLS lo enforce). El user puede tener
 * múltiples reminders sobre la misma tarea (ej: aviso a las 9, otro a las 14).
 */
import { supabase } from '@/lib/supabase';

// task_reminders es post-Snapshot · no está aún en database.types.ts (se
// regenera al final del sprint). Tipado local en este archivo.
export interface TaskReminderRow {
  id: string;
  task_id: string;
  user_id: string;
  remind_at: string;
  note: string | null;
  sent: boolean;
  created_at: string;
  created_by: string | null;
}

export interface CreateReminderInput {
  task_id: string;
  remind_at: string;
  note?: string | null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = supabase as any;

export async function listMyReminders(): Promise<TaskReminderRow[]> {
  const { data, error } = await db
    .from('task_reminders')
    .select('*')
    .order('remind_at', { ascending: true });
  if (error) throw error;
  return (data ?? []) as TaskReminderRow[];
}

export async function listRemindersForTask(taskId: string): Promise<TaskReminderRow[]> {
  const { data, error } = await db
    .from('task_reminders')
    .select('*')
    .eq('task_id', taskId)
    .order('remind_at', { ascending: true });
  if (error) throw error;
  return (data ?? []) as TaskReminderRow[];
}

export async function createReminder(input: CreateReminderInput, userId: string): Promise<void> {
  const { error } = await db.from('task_reminders').insert({
    task_id: input.task_id,
    user_id: userId,
    remind_at: input.remind_at,
    note: input.note ?? null,
    created_by: userId,
  });
  if (error) throw error;
}

export async function deleteReminder(id: string): Promise<void> {
  const { error } = await db.from('task_reminders').delete().eq('id', id);
  if (error) throw error;
}
